import type { ReactNode } from 'react';

export const symbol_data_array: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M630-160q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h110v-520H630q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h110q24.75 0 42.38 17.62Q800-764.75 800-740v520q0 24.75-17.62 42.37Q764.75-160 740-160H630Zm-410 0q-24.75 0-42.37-17.63Q160-195.25 160-220v-520q0-24.75 17.63-42.38Q195.25-800 220-800h110q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H220v520h110q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H220Z"
		/>
	</svg>
);
